import { useEffect, useState } from "react";
import websocketClient from "../utils/websocketClient";

const useNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const CLIENT_URL =process.env.REACT_APP_CLIENT_BASE_URL

  const WS_URL = process.env.REACT_APP_WS_BASE_URL;

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token) return;

    const url = `${WS_URL}/ws/notifications/`;

    websocketClient.connect("notifications", url, token);

    const handleMessage = (data) => {
      // console.log("🔔 Notification received:", data);

      // if (data.notifications) {
      //   setNotifications((prev) => [...data.notifications, ...prev]);
      // } else {
      //   setNotifications((prev) => [data, ...prev]);
      // }
      if (data.notifications) {
        // initial load or refresh from server
        setNotifications(data.notifications);
        if (typeof data.total_unread_notifications === "number") {
          setUnreadCount(data.total_unread_notifications);
        }
      } else {
        // single new notification
        setNotifications((prev) => {
          if (prev.some((n) => n.id === data.id)) return prev;
          return [data, ...prev];
        });

        // increment unread count if new one is unread
        if (!data.is_read) {
          setUnreadCount((prev) => prev + 1);
        }
      }
    };

    websocketClient.subscribe("notifications", handleMessage);

    return () => {
      websocketClient.unsubscribe("notifications", handleMessage);
      websocketClient.disconnect("notifications");
    };
  }, []);

  const markAsRead = (id) => {
    setNotifications((prev) =>
      prev.map((n) => (n.id === id ? { ...n, is_read: true } : n))
    );
    setUnreadCount((prev) => (prev > 0 ? prev - 1 : 0));
  };

  return { notifications, unreadCount , markAsRead , setUnreadCount , setNotifications};
};

export default useNotifications;
